type BaseSelectOptionExtraProps = {
  archived?: boolean;
  description?: string;
  deleted?: boolean;
  disabled?: boolean;
  disabledTooltip?: React.ReactNode;
  group?: string;
  hidden?: boolean;
  icon?: React.ComponentType<{ className?: string }>;
};

type EntityOption = BaseSelectOptionExtraProps & {
  id: string;
  name: string;
};

type FormattedOption = BaseSelectOptionExtraProps & {
  label: string;
  value: string;
};

type CountryOption = BaseSelectOptionExtraProps & {
  code: string;
  name: string;
};

export type BaseSelectOption = EntityOption | CountryOption | FormattedOption;

export type SelectOption<T = object> = Omit<T, 'id' | 'code' | 'name'> & {
  description?: string;
  disabled?: boolean;
  disabledTooltip?: React.ReactNode;
  hidden?: boolean;
  label: string;
  value: string;
} & T;

export const mapToSelectOptions = <T extends BaseSelectOption>(items: T[] | undefined): SelectOption<T>[] => {
  return items
    ? items
        .map((item) => {
          return {
            ...item,
            hidden: item.hidden || item.archived || item.deleted,
            label: 'name' in item ? item.name : item.label,
            value: 'id' in item ? item.id : 'code' in item ? item.code : item.value,
          };
        })
        .sort((a, b) => a.label.localeCompare(b.label))
    : [];
};
